import { API_STATES } from "@/helpers";

const state = {
  availabilitiesGetState                  : API_STATES.NOT_REQUESTED,
  availabilityDeleteState                 : API_STATES.NOT_REQUESTED,
  availabilitiesGetError                  : null,
  availabilityDeleteError                 : null,
  availabilities                          : [],
  availabilityCreateState                 : API_STATES.NOT_REQUESTED,
  availabilityCreateError                 : null,
  availabilityUpdateState                 : API_STATES.NOT_REQUESTED,
  availabilityUpdateError                 : null,
  availability                            : {},
  addAvailabilityScheduleState            : API_STATES.NOT_REQUESTED,
  addAvailabilityScheduleError            : null,
  deleteAvailabilityScheduleState         : API_STATES.NOT_REQUESTED,
  deleteAvailabilityScheduleError         : null,
  availabilityScheduleWeekDayState        : API_STATES.NOT_REQUESTED,
  availabilityScheduleWeekDayUpdateError  : null,
  availabilityScheduleFromTimeUpdateState : API_STATES.NOT_REQUESTED,
  availabilityScheduleFromTimeUpdateError : null,
  availabilityScheduleToTimeUpdateState   : API_STATES.NOT_REQUESTED,
  availabilityScheduleToTimeUpdateError   : null,
  userAvailabilityCreateState             : API_STATES.NOT_REQUESTED,
  userAvailabilityCreateError             : null,
};

export default state;